/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_F3Inputs */

const en_mk_sol_ukm_f3 = /** @type {(inputs: Mk_Sol_Ukm_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A WhatsApp group per branch, notebooks, a sales spreadsheet`)
};

const id_mk_sol_ukm_f3 = /** @type {(inputs: Mk_Sol_Ukm_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup WhatsApp per cabang, buku catatan, spreadsheet penjualan`)
};

/**
* | output |
* | --- |
* | "A WhatsApp group per branch, notebooks, a sales spreadsheet" |
*
* @param {Mk_Sol_Ukm_F3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_f3 = /** @type {((inputs?: Mk_Sol_Ukm_F3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_F3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_f3(inputs)
	return en_mk_sol_ukm_f3(inputs)
});